import { RectangleGroupIcon } from '@heroicons/react/24/outline'
import { companyTypeOptions } from './constants/statusOptions'
import { SearchQuery } from './filter/SearchQuery'
import { SelectFilter } from './filter/SelectFilter'
import { useCompanyFilters } from './hooks/useCompanyFilters'
import { SelectionSummary } from './SelectionSummary'

export const FiltersRow = () => {
  // Use the nuqs-based filter hook
  const {
    filters,
    updateSearch,
    updateType,
    clearAllFilters,
    hasActiveFilters,
  } = useCompanyFilters()

  const handleClearFilters = () => {
    // Clear nuqs filters
    clearAllFilters()
  }

  // Check if any filters are active - now only using nuqs filters
  const hasAnyActiveFilters = hasActiveFilters

  return (
    <div className="mb-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <SearchQuery
            onSearchChange={updateSearch}
            placeholder="Buscar compañía..."
            searchQuery={filters.search}
          />

          <SelectFilter
            activeSelections={filters.type}
            icon={<RectangleGroupIcon className="h-4 w-4" />}
            onSelectionsChange={updateType}
            placeholder="Buscar tipo..."
            searchActive={false}
            selectionOptions={companyTypeOptions}
            title="Tipo"
          />
        </div>

        {hasAnyActiveFilters && (
          <SelectionSummary
            // Active nuqs filters
            handleClearFilters={handleClearFilters}
            searchQuery={filters.search}
            setSearchQuery={updateSearch}
            setType={updateType}
            type={filters.type}
            typeOptions={companyTypeOptions}
          />
        )}
      </div>
    </div>
  )
}
